export default "__VITE_ASSET__DUG5i_DD__"